module.exports = __webpack_public_path__ + "static/media/fifth_north_church2.12a52c5b.jpg";